import { EMAIL_VERIFICATION_COPY } from '../consts';
import type {
  ProfileEmailMode,
  ProfileEmailPillTone,
  ProfileEmailView,
  VerificationStatus,
} from '../types';

type ResolveProfileEmailViewInput = {
  status: VerificationStatus | null | undefined;
  mode: ProfileEmailMode;
  email: string;
  pendingEmail?: string | null;
  codeSentAt?: string | null;
  codeRequested: boolean;
};

const PROFILE_EMAIL_PROVIDER_COPY = {
  vk: {
    label: EMAIL_VERIFICATION_COPY.vkStatus,
    value: EMAIL_VERIFICATION_COPY.vkValue,
  },
  yandex: {
    label: EMAIL_VERIFICATION_COPY.yandexStatus,
    value: EMAIL_VERIFICATION_COPY.yandexValue,
  },
} as const;

export function resolveProfileEmailView(input: ResolveProfileEmailViewInput): ProfileEmailView {
  switch (input.status) {
    case 'vk':
    case 'yandex':
      return {
        kind: 'provider',
        provider: input.status,
        ...PROFILE_EMAIL_PROVIDER_COPY[input.status],
      };
  }

  if (input.mode === 'change') {
    return { kind: 'change' };
  }

  const awaitingCode = Boolean(
    input.codeRequested || input.pendingEmail || (input.codeSentAt && input.status !== 'email'),
  );

  if (awaitingCode) {
    return { kind: 'code', destination: input.pendingEmail || input.email };
  }

  switch (input.status) {
    case 'email':
      return { kind: 'verified', email: input.email };
    default:
      return { kind: 'unverified', email: input.email };
  }
}

export function resolveProfileEmailPill(view: ProfileEmailView): {
  label: string;
  tone: ProfileEmailPillTone;
} {
  switch (view.kind) {
    case 'provider':
      return { label: view.label, tone: 'provider' };
    case 'verified':
      return { label: EMAIL_VERIFICATION_COPY.verifiedStatus, tone: 'success' };
    case 'change':
      return { label: EMAIL_VERIFICATION_COPY.pendingStatus, tone: 'warning' };
    case 'code':
    case 'unverified':
      return { label: EMAIL_VERIFICATION_COPY.unverifiedStatus, tone: 'warning' };
  }
}
